module.exports = __webpack_public_path__ + "img/avatar7.2ff18a07.png";